// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","nain":"App_nain__P31bL","header":"App_header__fhC8n","footer":"App_footer__aawhi"};